import type { ICreateContestPayload } from '../../../redux/contest/types';
import type { TRequirements } from '../../../types/global/helper';
import { mapWizardGenresToApi, mapWizardRequirementsToApi, mapWizardTagsToApi } from './contestApiMappers';
import type { ContestWizardState } from './types';

export type ContestWizardCreatePayload = Omit<
    ICreateContestPayload,
    'feature_image' | 'mobile_feature_image' | 'contest_media' | 'requirements'
> & {
    categories?: ContestWizardState['categories'];
    requirements: TRequirements[];
    feature_image?: File[];
    mobile_feature_image?: File[];
    contest_media?: File[];
    submission_state?: ContestWizardState['submission_state'];
    submission_state_message?: string;
    contest_reference?: ContestWizardState['contest_reference'];
    playlist?: ContestWizardState['playlist'];
    score_criteria?: ContestWizardState['score_criteria'];
};

export function buildContestPayloadFromWizard(state: ContestWizardState): ContestWizardCreatePayload {
    return {
        title: state.title.trim(),
        description: state.description.trim(),
        requirements: mapWizardRequirementsToApi(state.requirements),
        submission_state: state.submission_state,
        submission_state_message: state.submission_state_message,
        tag: mapWizardTagsToApi(state.tag),
        genre: mapWizardGenresToApi(state.genre),
        categories_enabled: state.categories_enabled,
        late_entry: state.late_entry,
        preselection_enabled: state.preselection_enabled,
        entry_type: state.entry_type,
        ...(state.max_participants != null && state.max_participants > 0
            ? { max_participants: state.max_participants }
            : { max_participants: null }),
        hide_submissions_count: Boolean(state.hide_submissions_count),
        contest_phases_enabled: state.contest_phases_enabled,
        contest_phase_dates: state.contest_phases_enabled ? state.contest_phase_dates : [],
        voting_required: state.voting_required,
        voting_type: state.voting_type as ICreateContestPayload['voting_type'],
        rating: state.rating as ICreateContestPayload['rating'],
        contest_reference: state.contest_reference,
        playlist: state.playlist,
        technical_spec: state.technical_spec as ICreateContestPayload['technical_spec'],
        score_criteria: state.score_criteria,
        date_start: state.contest_phase_dates[0]?.date_started || '',
        expiration_date: state.contest_phase_dates[0]?.expiration_date || '',
        categories: state.categories_enabled
            ? state.categories.map(c => ({
                  ...c,
                  with_tiered_pricing: c.with_tiered_pricing !== false,
                  with_fee: c.with_fee !== false,
              }))
            : undefined,
        feature_image: state.feature_image_file ? [state.feature_image_file] : undefined,
        mobile_feature_image: state.mobile_feature_image_file ? [state.mobile_feature_image_file] : undefined,
        contest_media: state.contest_media_files.length ? state.contest_media_files : undefined,
    };
}
